import React from 'react';

const BidlogPage: React.FC = () => {
  return (
    <div
      className="main_box_style"
      style={{
        padding: '10px 25px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
        height: 600 ,// Added shadow
        fontWeight: 400,
        fontSize: 14,
      }}
    >
      <h3>Bid Automation:</h3>
      <table
        width="100%"
        border={0}
        cellSpacing={0}
        cellPadding={2}
        align="center"
        style={{ margin: '10px' }}
        className="bdv_000000_Text_11"
      >
        <tbody>
          <tr>
            <td width="100%">Bid Automation is not enabled</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default BidlogPage;
